import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface IProps {
  actionUrl: string;
  actionText?: string;
  actionLinkAsSpan?: boolean;
}

const StyledSpanLink = styled.span`
  font: inherit;
  font-weight: 600;
  color: ${theme.colors.white};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: ${theme.colors.white};
  }
`;

const KubitTooltipLink = ({
  actionUrl,
  actionText,
  actionLinkAsSpan,
}: IProps) => {
  const label = actionText ?? 'Learn More';

  // In some situations we need to render a span instead of anchor(<a>).
  // For example when we use KubitTooltip with a link for KubitContextualMenu options
  // KubitContextualMenu is using <button> tag and <a> inside of it will not work
  const openInNewTab = () => {
    window.open(actionUrl, '_blank', 'noreferrer');
  };

  if (actionLinkAsSpan) {
    return (
      <StyledSpanLink onMouseDown={openInNewTab} title={actionUrl}>
        {label}
      </StyledSpanLink>
    );
  }

  return (
    <StyledSpanLink as={Link} to={actionUrl} target="_blank">
      {label}
    </StyledSpanLink>
  );
};

export default KubitTooltipLink;
